import React from "react";
import ReactDOM from "react-dom";

import "antd-mobile/dist/antd-mobile.css";
import enUS from "antd-mobile/lib/locale-provider/en_US";
import { LocaleProvider } from "antd-mobile";

import "./index.css";
import "moment/locale/pt-br";
import "./utils/stringExtensions";

import { App } from "./App";

import * as serviceWorker from "./serviceWorker";
import numeral from "numeral";
import { createTheme, ThemeProvider } from "@material-ui/core";

numeral.register("locale", "br", {
  delimiters: {
    thousands: ".",
    decimal: ",",
  },
  abbreviations: {
    thousand: "k",
    million: "m",
    billion: "b",
    trillion: "t",
  },
  ordinal: function (number) {
    return "º";
  },
  currency: {
    symbol: "R$",
  },
});

numeral.locale("br");

const smallTheme = createTheme({
  spacing: 4,
  props: {
    MuiButton: {
      size: "small",
    },
    MuiFilledInput: {
      margin: "dense",
    },
    MuiFormControl: {
      margin: "dense",
    },
    MuiFormHelperText: {
      margin: "dense",
    },
    MuiIconButton: {
      size: "small",
    },
    MuiInputBase: {
      margin: "dense",
    },
    MuiInputLabel: {
      margin: "dense",
    },
    MuiListItem: {
      dense: true,
    },
    MuiOutlinedInput: {
      margin: "dense",
    },
    MuiFab: {
      size: "small",
    },
    MuiTable: {
      size: "small",
    },
    MuiTextField: {
      margin: "dense",
    },
    MuiToolbar: {
      variant: "dense",
    },
  },
  overrides: {
    MuiListItem: {
      gutters: {
        paddingLeft: 8,
        paddingRight: 8,
      },
    },
    MuiIconButton: {
      sizeSmall: {
        // Adjust spacing to reach minimal touch target hitbox
        marginLeft: 4,
        marginRight: 4,
        padding: 12,
      },
    },
  },
});

ReactDOM.render(
  <ThemeProvider theme={smallTheme}>
    <LocaleProvider locale={enUS}>
      <App />
    </LocaleProvider>
  </ThemeProvider>,
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
